'use client'

import type { FC, ReactNode } from 'react'

import { EmptyDataIcon, EmptySearchIcon, PermissionDeniedIcon } from '~/core/ui/FillIcons'
import type { LucideIconName } from '~/core/ui/IconWrapper'
import { TextButton } from '~/core/ui/TextButton'
import { Tooltip } from '~/core/ui/Tooltip'
import { cn } from '~/core/ui/utils'

const Empty: FC<{
  type?: 'empty-data' | 'empty-search' | 'permission-denied'
  title?: string
  description?: string
  buttonTitle?: string
  buttonClassNameText?: string
  buttonIcon?: LucideIconName
  buttonDisabled?: boolean
  buttonTooltipContent?: ReactNode
  isShowIcon?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  className?: string
  classNameIcon?: string
  classNameTitleWrapper?: string
  size?: 'sm' | 'md'
}> = (props) => {
  const {
    type = 'empty-data',
    title = '',
    description = '',
    buttonTitle,
    buttonClassNameText = '',
    buttonDisabled = false,
    buttonTooltipContent,
    isShowIcon = true,
    buttonIcon,
    onClick,
    className = 'max-w-[400px]',
    classNameIcon = '',
    classNameTitleWrapper = 'mt-4',
    size = 'md'
  } = props

  return (
    <div
      className={cn(
        'm-auto flex flex-col items-center justify-center',
        className
      )}>
      {isShowIcon && (
        <div
          className={cn(
            'tablet:h-[80px] tablet:min-h-[80px] tablet:w-[80px] tablet:min-w-[80px] flex h-[60px] min-h-[60px] w-[60px] min-w-[60px] items-center justify-center',
            classNameIcon
          )}>
          {type === 'empty-search' ? (
            <EmptySearchIcon />
          ) : type === 'permission-denied' ? (
            <PermissionDeniedIcon />
          ) : (
            <EmptyDataIcon />
          )}
        </div>
      )}

      <div className={`mb-1 ${isShowIcon ? classNameTitleWrapper : ''}`}>
        <h3
          className={cn(
            'text-center font-medium text-gray-900 dark:text-gray-300',
            isShowIcon || size === 'sm' ? 'text-base' : 'text-lg'
          )}>
          {title}
        </h3>
      </div>

      <div className={buttonTitle ? 'mb-2' : ''}>
        <p
          className={`text-center ${isShowIcon || size === 'sm' ? 'text-sm' : 'text-base'} text-gray-600 dark:text-gray-400`}>
          {description}
        </p>
      </div>

      {buttonTitle ? (
        buttonTooltipContent ? (
          <Tooltip content={buttonTooltipContent}>
            <TextButton
              size={isShowIcon ? 'md' : 'lg'}
              onClick={(e) => onClick && onClick(e)}
              label={buttonTitle}
              classNameText={`${buttonClassNameText} font-medium`}
              iconMenus={buttonIcon}
              underline={false}
              isDisabled={buttonDisabled}
            />
          </Tooltip>
        ) : (
          <TextButton
            size={isShowIcon ? 'md' : 'lg'}
            onClick={(e) => onClick && onClick(e)}
            label={buttonTitle}
            classNameText={`${buttonClassNameText} font-medium`}
            iconMenus={buttonIcon}
            underline={false}
            isDisabled={buttonDisabled}
          />
        )
      ) : null}
    </div>
  )
}

export default Empty
